import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const LocationSelector = () => {
    const [selectedLocation, setSelectedLocation] = useState('Mumbai, Maharashtra');

    const locations = [
        "Mumbai, Maharashtra",
        "Delhi, NCR",
        "Bangalore, Karnataka",
        "Hyderabad, Telangana",
        "Chennai, Tamil Nadu",
        "Pune, Maharashtra"
    ];

    const [isOpen, setIsOpen] = useState(false);

    const handleLocationSelect = (location) => {
        setSelectedLocation(location);
        setIsOpen(false);
    };

    return (
        <div className="relative">
            <button
                onClick={() => setIsOpen(!isOpen)}
                className="flex items-center gap-2 px-3 py-2 md:px-4 md:py-2.5 rounded-lg bg-card border border-border hover:bg-muted transition-all"
                aria-label="Select location"
                aria-expanded={isOpen}
            >
                <Icon name="MapPin" size={18} color="var(--color-primary)" />
                <span className="text-sm md:text-base font-medium text-foreground">
                    {selectedLocation}
                </span>
                <Icon
                    name={isOpen ? "ChevronUp" : "ChevronDown"}
                    size={16}
                    color="var(--color-muted-foreground)"
                />
            </button>
            {isOpen && (
                <>
                    <div
                        className="fixed inset-0 z-40"
                        onClick={() => setIsOpen(false)}
                        aria-hidden="true"
                    />
                    <div className="absolute top-full left-0 right-0 mt-2 py-2 bg-popover border border-border rounded-lg shadow-lg z-50 max-h-64 overflow-y-auto">
                        {locations?.map((location) => (
                            <button
                                key={location}
                                onClick={() => handleLocationSelect(location)}
                                className={`w-full px-4 py-2.5 text-left text-sm md:text-base hover:bg-muted transition-colors ${location === selectedLocation
                                        ? 'bg-primary/10 text-primary font-medium' : 'text-foreground'
                                    }`}
                            >
                                {location}
                            </button>
                        ))}
                    </div>
                </>
            )}
        </div>
    );
};

export default LocationSelector;